<template>
  <div id="score-exhcange" :class="theme">
      <div class="header-part">
          <img :src="userImg ? userImg : defaultImg" alt="">
          <div class="info-box">
              <span class="bold">{{username}}</span><br/>
              <span>可用积分：<strong>{{score}}</strong></span>
          </div>
      </div>
      <div class="row">
          <span class="left-part">
            <img :src="coinLogo" alt="">
            <span>GZT</span>
          </span>
          <span class="right-part">兑换比例：{{rateShow}}</span>
      </div>
      <div class="input-row">
          <div class="input-box">
              <input v-model="inputScroe" type="number" placeholder="请输入要兑换的积分数量">
              <span class="unit">积分</span>
              <span class="all-btn" @click="inputScroe = score">全部</span>
          </div>
          <div class="tip-box">
              <span class="count">可兑换{{inputScroe * rate}} GZT</span>
              <span class="tip">历史累计3000积分后即可兑换</span>
          </div>
      </div>
      <div class="exchange-btn" :class="enableEx && inputScroe ? 'active' : ''" @click="exchangeScore">申请兑换</div>
      <div class="rules">
            <h2>兑换规则：</h2>
            <p>1.积分兑换功能仅支持金果子pro版，用户积分达3000分后方可申请兑换。</p>
            <p>2.新获得的积分，5日后可参与兑换。</p>
            <p>3.积分兑换最低500积分起。</p>
            <p>4.申请兑换后，将在7个工作日内审核完毕。</p>
            <p>5.实际可用积分由您的账户情况、历史兑换情况等综合因素决定。</p>
            <p>6.活动最终解释权归金果子所有。如有疑问，请联系金果子官方客服。(微信号:jgzcom)</p>
      </div>
      <jgz-loading :loading-show='showLoading'></jgz-loading>
      <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
        <div v-show="isiOS" class="ios-warn">本活动与苹果公司无关</div>
  </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'ScoreExhcange',
    data() {
        return {
            isiOS: false,
            message: null,
            alertShow: false,
            showLoading: false,
            // defaultImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAFiUlEQVRoQ+1aSY8bVRD+qr2Np3uWRAlMxh5AHDkMEUsEiEwOYVHEcgDBP+DOKQgRCQmkSMCBH8APQEA4BUWRBiEgAolNw3LgmBD3QEiAydjtZbwVqm73Mnbb3a/dmowQdbO7Xr33dVW92pqQInH1t0dBmZdB/DhA86GimasArYPpXZovfZXW9jStIK5dPQPS3pxKDuE10stnp5GRCAgzZ1Hf/AHA6q7N+x2gXQN6LQAcfi7SAK0A5OcALTfM8zP00v1E1FUFpQyEa+Y6CI95G/XbQPOv8QePPBEBxUOAlvc5Ges0V34icmmAITYQtsx7Afzore3UgfZNlb2iefOLQE73+XLZVSos/RK9EIgFhC3zPICnbYH9LtD8M47s5DzF2wEt664/T0b52ShhkUDYMq8AuNMW1Pp7YP9RYlN4nikCMwcdQUSXSS/dPUnqRCBsmXUAs7aA+mYKp0sgQi+5ixpklAN2t1vWWCBsmSYAR8qtAuGe1QdTIaN8R9jrCAXC1uZFgJ/cFyBGwNBFMkqnhsGMAOFG5Rj69M2+AjEMhrQHSF+WOObRKBDLdCJZGo6dyfvxQeJNr53ASQJLAhcAGeVdZ9/1gy3zcwAnIBG6eT3ZpvkFIGdMXtupAe1qMvnu1cz4jObKJ10hHhDm73OoLzmvLIlzS9ohEVqFmjcA0ZQquc6vl/JE1JHlPhDL/MnOnToW0N5WEx1HC+MkimZEQyrk77dBRvm+YSCOb6hqQ8xIBE9DO1tAt6EmYaAV11dsjbC1eRrgt2xnbN1QEEiAvqzAP4FV9QXOHAbkMgGdJqP0zgDI4Kaq/yHJVPyDzS5L+hCffxInM9D4XUGWBuhHbH7RyhAQlTQkRW24x1fVSsC8iBvmw+jja/R7QPNa/DdSOAhki/H543CqXjSzSwBlAI0fIrbMDwC8iJ2bQFdyxJjk5z8xF8RkU9FKVgcKi2Jc7xPXzRoYBlT9Yz8AkbJ5VvyEq6KRZNfufgAiSnb95H8g/xmNFA4AWad4TI2SNDSmNi1J09KK6knjSCo+IkJuaWQfoPc0UjOrIMyhLunBmO7gWNtJUSsq8cM9j3f9UlXiyDkwnkeSDFQE5uaAfHi/OrbvJN3bC4j4iLh2dQ2kfTFV422v6xH3DRWXAC0D9On4FEnj0PveywrR3TqYNMp/flBUTOPDbCeOdqap2Uf8I5jGV81XoeGsemEV4QWZgj86kKItSX0+bovi4UGHhl8hY+XtYM2eLOeK7dEpM4aVurZ51c1vwXgQSaJr8IxSw0vEHx3iOFzSapL6XGqPpOSNH/g7MlaOiZhAO+jDDOqPOJMi1Ts9jl+MO7RqMRWI5tBLGSKya/OhBl3lAkCnYl/FM4cA8YM0SMZ10t2MIn928gkZ5Wc83x9e591grS2gN6ZFI2ZTvC1qy2TPpcMp5hdGYrKSrA4aDkGWkN5vZRUgadYhNG1JUwvjoHabwM4/Q093pUNHySg7ZxxQ+FihXvkYTM+N+IuUlZLf7AUNj/jc+odwjvTyC8NHmDTouQzgLg+Mmw7sBQh3D7eZ7hVxfJmMldARXLzRm9imakszLcAySug1RVqy0Zt7Dq5fM5EtOiM4sV1WnuUng0RZv2/WbVRIPxI6cpvoI8M7c2vrS5B23P6f+2r9ryQwJD13fZH7l2jmwFqUmNiNW+5snUBfk0GQQ3butBMlX+25nZsFvoDQaI1y85fiCIkNxDO19vYGGEc94dxzTE65ugwYhbRepfXpC92gwqI994hLykBs6+JKEe35X70PCTyU7GhJ+shju/ryUU3WefMjnXy+guu1e2hlxfZuFUoEJLgB72zLJ05nVDYN4X2DCguvTyNjaiC7QLW2nwLhJRBO2v3kcLIA/hRM79HMwoVpDh9c+y9PCxMFQR39lgAAAABJRU5ErkJggg==',
            token: null,
            userImg: '',
            coinLogo: '',
            username: '',
            userId: null,
            enableEx: false,
            score: 0,
            inputScroe: null,
            rateShow: null,
            rate: 1,
            theme: 'day'
        }
    },
    components: {
        JgzLoading,
    },
    mounted: async function() {
        const u = navigator.userAgent;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        const params = this.$route.query
        this.token = params.auth
        this.userId = params.userId
        this.theme = params.theme
        this.showLoading = true
        this.getUserInfo()
        this.getUserScore()
    },
    computed: {
        defaultImg() { return this.$DefaultHead }
    },
    methods: {
        //  获取用户资料
        getUserInfo() {
            this.$MyAxios.init({ token: this.token })
            this.$MyAxios.get(`/api/user/accounts/${this.userId}/vitalInfo`, 
            { username: this.userId }, 
            response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.username = response.data.nickname ? response.data.nickname : response.data.username
                    this.userImg = response.data.avatar
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
            })
        },

        //  获取用户积分
        getUserScore() {
            this.$MyAxios.init({ token: this.token })
            this.$MyAxios.get(`/api/user/redeem/REDEEM_GZT`, 
            {
                params: { userId: this.userId, username: this.userId }
            }, 
            response => {
                if(response.code == 1) {
                    this.showLoading = false;
                    this.score = response.data.usefulIntegral
                    this.coinLogo = response.data.logo
                    this.enableEx = response.data.enableToRedeem
                    this.rateShow = response.data.rate
                    this.rate = response.data.rateValue
                }
            }, error => {
                this.showLoading = false;
                this.showAlert(error);
            })
        },

        //  兑换积分
        exchangeScore() {
            if(!this.enableEx || !this.inputScroe) {
                return
            }
            if(this.inputScroe > this.score) {
                this.showAlert("可用积分不足")
                return
            }
            if(this.inputScroe % 1 !== 0) {
                this.showAlert("积分必须为整数")
                return
            }
            this.$MyAxios.post('/api/user/redeem', 
            {
                userId: this.userId,
                username: this.userId,
                giftId: "1", 
                integralValue: this.inputScroe,
                giftCount: this.inputScroe,
                label: 'REDEEM_GZT'
            },
            false,
            response => {
                if(response.code === 1) {
                    this.showAlert("申请成功，请等待审核！")
                    this.score = this.score - this.inputScroe
                    this.inputScroe = ''
                    this.getUserScore()
                    this.openPage(response.data)
                }
            },
            error => {
                this.showAlert(error)
                his.openPage(error)
            })
        },
        
        //  打开app页面
        openPage(tag) {
            this.$setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('handleOpenScoreResult', {data: tag});
            });  

            if (window.androidHandler) {  
                let str = JSON.stringify({params: 'ScoreResultPage', data: tag});
                androidHandler.setValue(str);
            }
        },

        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
    }
}
</script>

<style lang='less'>
#score-exhcange {
    min-height: 100vh;
    background: #ffffff;
    .header-part {
        width: 100vw;
        height: 200px;
        background: linear-gradient(#ffa41f, #ffbc1f);
        display: flex;
        align-items: center;
        padding-left: 30px;
        margin-bottom: 30px;
        img {
            margin-right: 20px;
            height: 100px;
            width: 100px;
            border-radius: 50px;
        }
        .info-box {
            text-align: left;
            color: #ffffff;
            span {
                line-height: 42px;
                font-size: 30px;
            }
            .bold {
                font-weight: bold;
            }
            strong {
                font-size: 48px;
            }
        }
    }
    .row {
        position: relative;
        margin-bottom: 30px;
        .left-part {
            display: inline-block;
            width: 40vw;
            padding-left: 30px;
            text-align: left;
            img {
                width: 80px;
                height: 80px;
                margin-right: 15px;
                vertical-align: middle;
                border-radius: 40px;
            }
            span {
                font-size: 28px;
                font-weight: bold;
                color: #33333A;
            }
        }
        .right-part {
            display: inline-block;
            padding-right: 30px;
            width: 60vw;
            text-align: right;
            font-size: 28px;
            color: #9598A6;
        }
    }
    .input-row {
        padding: 0 30px;
        .input-box {
            border: 1px solid #EBECF0;
            height: 88px;
            border-radius: 8px;
            text-align: left;
            margin-bottom: 10px;
            overflow: hidden;
            input {
                height: 86px;
                width: 480px;
                font-size: 32px;
                outline:none;
                color: #33333A;
                border: none;
                text-indent: 20px;
            }
            .unit {
                font-size: 28px;
                display: inline-block;
                color: #33333A;
                padding-right: 20px;
                line-height: 40px;
                border-right: 1px solid #EBECF0;
                margin-right: 30px;
            }
            .all-btn {
                font-size: 28px;
                color: #ffa41f;
                cursor: pointer;
            }
        }
        .tip-box {
            font-size: 24px;
            text-align: left;
            margin-bottom: 60px;
            .count {
                color: #ffa41f;
                margin-right: 20px;
            }
            .tip {
                color: #9598A6;
            }
        }
    }
    .exchange-btn {
        height: 88px;
        border-radius: 8px;
        background: #CCCED9;
        line-height: 88px;
        color: #FFFFFF;
        font-size: 32px;
        margin: 0 30px 60px 30px;
        cursor: pointer;
        &.active {
            background: #ffa41f;
        }
    }
    .rules {
        text-align: left;
        padding: 0 30px;
        color: #33333A;
        line-height: 42px;
        h2 {
            font-size: 30px;
            margin-bottom: 10px;
            font-weight: bold;
        }
        p {
            font-size: 28px;
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-50%);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
    &.night {
        background: #08080A;
        color: #E3E3E1;
        .row{ 
            .left-part {
                span {
                    color: #E3E3E1;
                }
            }
            .right-part {
                color: #9D9DA6;
            }
        }
        .input-row {
            .input-box {
                border: 1px solid #2A2A36;
                background: #08080A;
                input {
                    color: #E3E3E1;
                    background: #08080A;
                }
                .unit {
                    color: #E3E3E1;
                    border-right: 1px solid #2A2A36;
                }
            }
        }
        .tip-box {
            .tip {
                color: #9D9DA6;
            }
        }
        .exchange-btn {
            background: #5C5D66;
            &.active {
                background: #ffa41f;
            }
        }
        .rules {
            color: #E3E3E1;
        }
        .alert {
            background: rgba(255, 255, 255, .9);
            color: #5C5D66;
        }
    }
    .ios-warn {
        position: absolute;
        width: 100vw;
        bottom: 10px;
        text-align: center;
        color: gray;
    }
}
</style>